module.exports = __webpack_public_path__ + "img/IMG_7057.5771eda4.webp";